import React, { useEffect, useState } from "react";
import { Form, Select, Input, Checkbox } from "antd";
import { useSearchParams } from "react-router-dom";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import { GetAllCountryApi, GetTermsAndConditionApi } from '../../api/request/common.js';
import { RegisterApi } from '../../api/request/users.js';
import toast from "react-hot-toast";
import { Link } from 'react-router-dom';
import { handleApiError } from "../../utils/handleApiError.js";
import { useResponsive } from "../../hooks/useResponsive.js";
import { cleareCookies } from "../../services/Cookies.jsx";

function Register() {

  const { isMobile } = useResponsive();
  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [tnc, setTnc] = useState([]);
  const [countryCodes, setCountryCodes] = useState([]);

  const refCode = (searchParams?.get('ref') || "").trim();
  const roleType = (searchParams?.get('role') || 'user').trim();


  const getTermsAndCondition = async () => {
    try {
      const { data } = await GetTermsAndConditionApi();
      if (data?.success) {
        setTnc(data?.data?.[0]);
      }
    } catch (error) { }
  }

  const getContriens = async () => {
    try {
      const { data } = await GetAllCountryApi();
      if (data?.success) {
        const items = Array.isArray(data?.data) ? data.data : [];
        setCountries(items.map((item) => ({ ...item, value: item?.id, label: item?.countryName })));
        const codeMap = new Map();
        items
          .map((item) => {
            const code1Raw = String(item?.countryCode1 || '').trim();
            const code2 = String(item?.countryCode2 || '').trim();
            if (!code1Raw) return null;
            const digits = code1Raw.replace(/[^0-9+]/g, '');
            const code1 = digits.startsWith('+') ? digits : `+${digits}`;
            const label = code2 ? `${code1} (${code2})` : code1;
            return { value: code1, label };
          })
          .filter(Boolean)
          .forEach((code) => {
            if (!codeMap.has(code.value)) {
              codeMap.set(code.value, code);
            }
          });
        const codes = Array.from(codeMap.values()).sort((a, b) =>
          a.label.localeCompare(b.label, undefined, { sensitivity: 'base' })
        );
        setCountryCodes(codes);
      }
    } catch (error) { }
  }

  useEffect(() => {
    getContriens();
    getTermsAndCondition();
  }, []);

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      const cc = String(values?.countryCode || '').trim();
      const pn = String(values?.phoneNo || '').trim();
      const payload = {
        ...values,
        phoneNo: `${cc}${pn}`,
        domain: "upforex.com",
        role: roleType
      }
      cleareCookies()
      const { data } = await RegisterApi(payload);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        setSearchParams('tab=login');
      }
      setIsLoading(false);
    } catch (error) {
      handleApiError(error);
      setIsLoading(false);
    }
  }
  const filterOption = (input, option) => {
    const query = String(input || '').toLowerCase();
    const label = String(option?.label || '').toLowerCase();
    const value = String(option?.value || '').toLowerCase();
    return label.includes(query) || value.includes(query);
  }

  if (refCode) {
    form.setFieldsValue({ affiliateCode: refCode });
  }


  const renderTncLinks = () => {
    const normalizeUrl = (url) => String(url || '').replace(/[`]/g, '').trim();

    const items = Array.isArray(tnc?.termsAndConditions) ? tnc.termsAndConditions : [];
    if (items.length === 0) return null;

    return items
      .filter((item) => !!item?.fileUrl)
      .map((item, index, arr) => {
        const url = normalizeUrl(item.fileUrl);
        const label = item.label || item.fileName || 'View Document';
        return (
          <span key={item.id || index}>
            <a href={url} target="_blank" rel="noopener noreferrer" className="primary underline hover:underline duration-300 ms-1" >
              {label}
            </a>
            {index !== arr.length - 1 && ','}
          </span>
        );
      });
  };

  const isAllowKey = (e) => {
    if (e.ctrlKey || e.metaKey) {
      return;
    }
    const value = e.target.value;
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "End", "Home", "Enter"];
    if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
    if (/[0-9]/.test(e.key) && value.length >= 10) {
      e.preventDefault();
    }
  }

  const handlePhonePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData?.getData('text') || '';
    const normalized = pastedText.replace(/\D/g, '').slice(0, 10);
    form.setFieldValue('phoneNo', normalized);
  }

  return (
    <div className="auth-page ">
      {isMobile && <div className="my-5 mt-10">
        <p className="text-xl font-bold mb-2 text-dark-200">Register</p>
        <p className="text-gray-500">Welcome, Please register to access your Account</p>
      </div>}
      <Form autoComplete="off" form={form} onFinish={handleSubmit}>
        <div className="grid sm:grid-cols-2 grid-cols-1 gap-3 text-sm font-normal">
          <div>
            {!isMobile && <p className="text-[#585F70] font-semibold text-xs">First Name</p>}
            <Form.Item name='firstName' rules={[{ required: true, message: 'Please enter first name.' }]}>
              <Input placeholder="First name" className="border border-slate-200 md:border-[#d9d9d9] rounded-[14px] md:rounded-lg  w-full ps-3 md:ps-2 py-3 md:py-2 placeholder:text-xs" />
            </Form.Item>
          </div>
          <div>
            {!isMobile && <p className="text-[#585F70] font-semibold text-xs">Last Name</p>}
            <Form.Item name='lastName' rules={[{ required: true, message: 'Please enter last name.' }]}>
              <Input placeholder="Last name" className="border border-slate-200 md:border-[#d9d9d9] rounded-[14px] md:rounded-lg w-full ps-3 md:ps-2 py-3 md:py-2 placeholder:text-xs" />
            </Form.Item>
          </div>
          <div className="sm:col-span-2">
            <p className="text-[#585F70] font-semibold text-xs">Email</p>
            <Form.Item name='email' rules={[{ required: true, type: 'email', message: 'Please enter valid email.' }]}>
              <Input placeholder="Email-id" className="border border-slate-200 md:border-[#d9d9d9] rounded-[14px] md:rounded-lg w-full ps-3 md:ps-2 py-3 md:py-2 placeholder:text-xs" />
            </Form.Item>
          </div>
          <div className="sm:col-span-2">
            <p className="text-[#585F70] font-semibold text-xs">Phone No.</p>
            <div className="flex gap-2">
              <Form.Item
                name='countryCode'
                rules={[{ required: true, message: 'Please select country code.' }]}
                className="inline-block w-1/3"
              >
                <Select
                  showSearch
                  optionFilterProp="label"
                  filterOption={filterOption}
                  options={countryCodes}
                  optionLabelProp="value"
                  placeholder={<p className="text-xs">+Code</p>}
                />
              </Form.Item>
              <Form.Item
                name='phoneNo'
                rules={[{ required: true, message: 'Please enter phone number.' }]}
                className="inline-block w-3/4"
              >
                <Input
                  maxLength={10}
                  placeholder="Phone No."
                  className="border border-slate-200 md:border-[#d9d9d9] rounded-[14px] md:rounded-lg w-full ps-3 md:ps-2 py-3 md:py-2 placeholder:text-xs"
                  onKeyDown={(e) => isAllowKey(e)}
                  onPaste={handlePhonePaste}
                />
              </Form.Item>
            </div>
          </div>
          <div className="w-full">
            {!isMobile && <p className="text-[#585F70] font-semibold text-xs">Select Country</p>}
            <Form.Item name="countryId" rules={[{ required: true, message: 'Please select a country.' }]}>
              <Select showSearch filterOption={filterOption} options={countries} placeholder={<p className="text-xs">Select country</p>} dropdownAlign={{ offset: [0, 0] }} popupClassName="custom-select-dropdown" />
            </Form.Item>
          </div>
          <div className="w-full">
            <p className="text-[#585F70] font-semibold text-xs">Referral Code (Optional)</p>
            <Form.Item name="affiliateCode">
              <Input placeholder="Referral code" className="border border-slate-200 md:border-[#d9d9d9] rounded-[14px] md:rounded-lg w-full ps-3 md:ps-2 py-3 md:py-2 placeholder:text-xs" />
            </Form.Item>
          </div>

        </div>
        <div>
          <Form.Item name='conditions' valuePropName="checked" rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')), }]} >
            <Checkbox className='mt-3 text-xs'>Yes, I agreed to the Terms and conditions</Checkbox>
          </Form.Item>
        </div>
        <div className="flex flex-wrap gap-1  text-[10px]">
          {renderTncLinks()}
        </div>
        <div className="mt-4">
          <LoadableButton type='submit' className='bg-primary text-[#FFFFFF] font-semibold text-base rounded-lg w-full py-2 text' lable='Open Account' isLoading={isLoading} />
        </div>
        <div className="text-center text-sm mt-4">
          <p>Already have an account? <Link to="/" className="primary underline">sign in</Link></p>
        </div>
      </Form>
    </div>
  );
}
export default Register;
